import { Link, Redirect } from '@reach/router'
import { find } from 'lodash'
import React from 'react'
import styled from 'styled-components'
import { color, space } from 'styled-system'

import Info from './lib/info'
import { ReactComponent as Logo } from './lib/logo.svg'
import A from '../ui/a'
import config from '../.lyzer/config.json'

export default ({ route }) => {
  const form = find(config.forms, form => form.meta.route === route)
  if (!form) return <Redirect noThrow to='/forms' />
  return <ConfirmationPage form={form} />
}

export const ConfirmationPage = ({ form }) => {
  return (
    <Wrapper>
      <Flex>
        <Info />
        <Logo />
      </Flex>
      <Title mt={2} mb={3}>
        {form.meta.name}
      </Title>
      <Box>
        <Subtitle pt={3} pb={4}>
          {form.process.confirmationTitle}
        </Subtitle>
        <Text py={3} mx='auto'>
          {form.process.confirmationMessage}
        </Text>
        <RightA pr={6} as={Link} to='/forms'>
          Return to Salem Forms
        </RightA>
      </Box>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin: 0 auto;
  margin-top: 32px;
  max-width: 768px;
`

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Box = styled.div`
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  min-height: calc(100vh - 193px);
  ${color}
  ${space}
`
Box.defaultProps = { p: 4, bg: 'lightgray' }

const Title = styled.div`
  font-size: 16px;
  text-transform: uppercase;
  text-align: center;
  ${space}
`

const Subtitle = styled.div`
  font-weight: 500;
  font-size: 24px;
  text-align: center;
  ${space}
`

const Text = styled.div`
  font-size: 14px;
  max-width: 519px;
  ${space}
`

const RightA = styled(A)`
  text-align: right;
`
